import * as Init from '../init.js';
import {
    CLAPI
} from '../clchart/cl.api.js'
import * as DATAS from '../datas/transdata.js'
import * as ADJUST from './adjust.res.js'
import * as COMMON from './common.res.js'

function getAdjustClass(inData) {
    let mclassindex = Init.getUserInfo(inData.modulename, 'mclassindex', -1)
    if (mclassindex < 0 || mclassindex > inData.moduledata.length - 1) {
        mclassindex = 0;
        Init.setUserInfo(inData.modulename, 'mclassindex', 0)
    }
    return inData.moduledata[mclassindex];
}

function setNameCtrl(curChart, chartName, inData, region) {
    const chart = curChart.getChart(chartName)
    const curRect = CLAPI.getChartRect(region)
    const ctrls = []
    const names = ['量化多头', '量化择时']
    for (let wvi = 0; wvi < inData.moduledata.length; wvi++) {
        ctrls.push({
            label: names[wvi], // inData.moduledata[wvi],
            clickValue: inData.moduledata[wvi],
        })
    }
    const curCfg = {
        layout: {
            title: {
                pixel:  ADJUST.FHEIGHT * 0.6, // 字体大小
                height: ADJUST.FHEIGHT, // 最大高度
                spaceX: ADJUST.FHEIGHT * 0.1, // X方向留空
                spaceY: ADJUST.FHEIGHT * 0.2, // Y方向留空
            }
        },
        config: {
            style: 'horizontal', // 'vertical'
            // title: {
            //     label: '调仓分类',
            // },
            maxchs: 5,
            ctrls: ctrls
        },
        rectMain: curRect

    }
    let mclassindex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, 'mclassindex', 0), inData.moduledata.length)
    curCfg.config.selectIndex = mclassindex;
    
    chart.createChart(chartName, 'system.ctrls', curCfg, function (result) {
        // 这里应该返回交互信息 比如按钮按下 光标位置等
        console.log(chartName, result)
        if (result.event === 'onclick') {
            onLoadClass(inData, 'showFace')
        }
        if (result.event === 'btndown') {
            Init.setUserInfo(inData.modulename, 'mclassindex', result.selectIndex)
            onLoadClass(inData, 'showFace')
        }
    })
}
function setDateCtrl(curChart, chartName, inData, region) {
    const chart = curChart.getChart(chartName)
    
    function setDateCtrlInfo(index, fname, vrate, stocks, holdsr) {
        // console.log(index, fname);
        const info = {
            color : CLAPI.getLineColor(index),
            label: fname,
            align : 'left',
            clickValue: fname,
            value : [],
        }
        {
            let clr = 'txt'
            if (vrate > 0) {
                clr = 'red'
            }
            if (vrate < 0) {
                clr = 'green'
            }
            info.value.push({
                label : CLAPI.Utils.formatFloat(Math.abs(vrate) * 100.0, 1, 4) + '%',
                // align : 'right',
                color : clr,
            })
        }
        {
            let clr = 'txt'
            info.value.push({
                label : CLAPI.Utils.formatFloat(holdsr * 100.0, 1, 4) + '%',
                // align : 'right',
                color : clr,
            })
        }
        {
            let clr = 'txt'
            info.value.push({
                label : CLAPI.Utils.formatVolume(stocks, 1),
                // align : 'right',
                color : clr,
            })
        }
        return info
    }
    const ctrls = []
    for (let index = 0; index < inData['dates'].datas.length; index++) {
        const cdate = CLAPI.getData(inData['dates'], 'date', index)
        const mholds = CLAPI.getData(inData['dates'], 'cur_holds', index)
        const assets = CLAPI.getData(inData['dates'], 'cur_assets', index)
        const stocks = CLAPI.getData(inData['dates'], 'cur_stks', index)
        const drate = CLAPI.getData(inData['dates'], 'dreapr', index)
        const holdsr = mholds / assets
        // console.log(cdate, mholds, assets);
        
        ctrls.push(setDateCtrlInfo(index, cdate, drate, stocks, holdsr))
    }
    
    const wrate = CLAPI.getData(inData['dates'], 'wreapr', inData.lastDate > inData.diskDate ? 1 : 0)
    let wclr = 'txt'
    if (wrate > 0) {
        wclr = 'red'
    }
    if (wrate < 0) {
        wclr = 'green'
    }
    console.log(inData['dates'], wrate);
    const title = {
        height : ADJUST.FHEIGHT* 0.8,
        label : '收益详情',
        value : [
            {
                label : CLAPI.Utils.formatFloat(Math.abs(wrate) * 100.0, 1, 4) + '%',
                color : wclr,
            },
            {
                label : '⏬',
                color : wclr,
            },
            ]
    }


    const curCfg = {
        layout: {
            offset: { // 图形的偏移位置（不包括标题等），margin为整个图形区，offset仅仅是图形
                left: 1,
                top: 1,
                right: 0,
                bottom: 1,
            },
            title: {
                pixel:  ADJUST.FHEIGHT * 0.5, // 字体大小
                height: ADJUST.FHEIGHT * 0.8, // 最大高度
                spaceX: ADJUST.FHEIGHT * 0.1, // X方向留空
                spaceY: ADJUST.FHEIGHT * 0.2, // Y方向留空
            }
        },
        config: {
            style: 'vertical', // 'vertical'
            hidepage : true,
            title: title, 
            maxchs: 7,
            ctrls: ctrls
        },
        rectMain: CLAPI.getChartRect(region)
    }
    // console.log(ADJUST.CHART_LEFT_DATES);
    curCfg.config.selectIndex = Init.getUserInfo(inData.modulename, 'dateindex', 0)
    // console.log(curCfg.config.selectIndex);
    // const leftchart = 
    chart.createChart(chartName, 'system.ctrls', curCfg, function (result) {
        // 这里应该返回交互信息 比如按钮按下 光标位置等
        if (result.event === 'onclick') {
            onLoadClass(inData, 'showInfo', result.selectIndex)
        }
        if (result.event === 'btndown') {
            console.log(chartName, result)
            if (result.selectIndex == -1) {
                result.selectIndex = Init.getUserInfo(inData.modulename, 'dateindex', 0)
                drawAdjust(inData, 'showMain')
            }
            else {
                onLoadData(inData, 'showInfo', result.selectIndex)
            }
        }
    })
}

function setInfoCtrl(curChart, chartName, inData, region) {
    const chart = curChart.getChart(chartName)
    const curRect = CLAPI.getChartRect(region)
    const curCfg = {
            layout: {
                title: {
                    pixel:  ADJUST.FHEIGHT * 0.5, // 字体大小
                    height: ADJUST.FHEIGHT * 0.8, // 最大高度
                    spaceX: ADJUST.FHEIGHT * 0.1, // X方向留空
                    spaceY: ADJUST.FHEIGHT * 0.2, // Y方向留空
                }
            },
            config: ADJUST.CHART_PHONE_INFOS,
            rectMain: curRect
        }
    const ainfoindex = Init.getUserInfo(inData.modulename, 'ainfoindex', 0)

    curCfg.config.selectIndex = ainfoindex
     
    const curchart = chart.createChart(chartName, 'system.ctrls', curCfg, function (result) {
        // 这里应该返回交互信息 比如按钮按下 光标位置等
        if (result.event === 'btndown') {
            // console.log(chartName, result)
            Init.setUserInfo(inData.modulename, 'ainfoindex', result.selectIndex)
            drawAdjust(inData, 'showInfo')
        }
    })
}


function setInfoList(curChart, chartName, inData, region) {
    const chart = curChart.getChart(chartName)

    const ainfoindex = Init.getUserInfo(inData.modulename, 'ainfoindex', 0)
    let tableInfo = ADJUST.AdjustInfo
    if (ainfoindex === 1) {
        chart.setData(chartName, inData['assets'])
        tableInfo = ADJUST.AssetsInfo
    }
    else {
        chart.setData(chartName, ADJUST.getInfoAdjust(inData['adjust']))
    }

    const mainLayoutCfg = {
        layout: {
            offset: {
                top: 5,
                bottom: 5,
                left: 5,
                right: 5
            },
        },
        config: CLAPI.Utils.mergeObjectOfDeep(
            {
                fieldlock  : 2,  // 按左键时，前面3个字段不动 
                fieldmins  : 5,             
                curKeyIdx  : 1,  // 用于检索curKey的字段索引
                header: {
                    pixel:  ADJUST.FHEIGHT * 0.5, // 字体大小
                    spaceX: ADJUST.FHEIGHT * 0.1, // X方向留空
                    spaceY: ADJUST.FHEIGHT * 0.2, // Y方向留空
                },
                // 配置信息
                record: {
                    pixel:  ADJUST.FHEIGHT * 0.5, // 字体大小
                    spaceX: ADJUST.FHEIGHT * 0.1, // X方向留空
                    spaceY: ADJUST.FHEIGHT * 0.2, // Y方向留空
                },
            }, CLAPI.ChartRes.CHART_TABLE),
        tableInfo : tableInfo,
        rectMain: CLAPI.getChartRect(region, 1, 1, 0, 0)
    }
    const mainchart = chart.createChart(chartName, 'system.table', mainLayoutCfg, function (result) {
        // 这里应该返回交互信息 比如按钮按下 光标位置等
        // console.log(result);
        if (result.event === 'headclick') {
        }
        if (result.event === 'changeselect') {
        }
        if (result.event === 'dataclick') {
        }
    })

    chart.bindData(mainchart, chartName)

}

function setMainBoard(curChart, chartName, inData, curRect) {
    const chart = curChart.getChart(chartName)  
    
    chart.setData(chartName, ADJUST.getadjustInfo(inData['money'], inData['stocks']))
       
    const curCfg = {
        layout: CLAPI.ChartRes.CHART_LAYOUT,
        config: CLAPI.Utils.mergeObjectOfDeep(ADJUST.CHART_BOARD_PHONE, CLAPI.ChartRes.CHART_BOARD),
        rectMain: curRect
    }
    const curchart = chart.createChart(chartName, 'system.board', curCfg, function (result) {
        //  console.log(result)
    })
    chart.bindData(curchart, chartName)
}

function setMainChart(curChart, chartName, inData, region) {
    const chart = curChart.getChart(chartName)
    
    const axisXinfo = DATAS.extractField(inData['money'], 'date')
    // 设置坐标显示信息
    chart.setAxisXinfo(axisXinfo)
    
    const wreapsName = chartName + 'wreaps'
    const wreaps = ADJUST.AdjustToData(inData['money'], 'wreap')
    chart.setData(wreapsName, wreaps)
    
    const dreapsName = chartName + 'dreaps'
    const dreaps = ADJUST.AdjustToData(inData['money'], 'dreap')
    chart.setData(dreapsName, dreaps)
    
    // console.log(axisXinfo, wreaps, dreaps);

    {
        const curRect = CLAPI.getChartRect(region, 1, 2, 0, 0)
        const curCfg = {
            layout: {
                offset: {
                    top: 5,
                    bottom: 5,
                    left: 5,
                    right: 5
                },
                title: {
                    pixel:  ADJUST.FHEIGHT * 0.3, // 字体大小
                    height: ADJUST.FHEIGHT * 0.45, // 最大高度
                    spaceX: ADJUST.FHEIGHT * 0.1, // X方向留空
                    spaceY: ADJUST.FHEIGHT * 0.1, // Y方向留空
                },
                // axisX: { // 纵坐标显示的配置
                //     pixel: ADJUST.FHEIGHT * 0.3,
                //     height: ADJUST.FHEIGHT * 0.3,
                //     width: ADJUST.FHEIGHT * 0.3,
                //     spaceX: ADJUST.FHEIGHT * 0.05,
                // },
            },
            config: CLAPI.Utils.mergeObjectOfDeep({
                    title: {
                        label: '累计盈亏',
                    },
                    lines: ADJUST.AdjustGetLines(1, 0),
                },
                ADJUST.CHART_MONEY_HEAD),
            rectMain: curRect
        }
        const curchart = chart.createChart(wreapsName, 'system.fixed', curCfg, function (result) {
        })
        chart.bindData(curchart, wreapsName)
    }
    {
        const curRect = CLAPI.getChartRect(region, 1, 2, 0, 1)
        const curCfg = {
            layout: {
                offset: {
                    top: 5,
                    bottom: 5,
                    left: 5,
                    right: 5
                },
                title: {
                    pixel:  ADJUST.FHEIGHT * 0.3, // 字体大小
                    height: ADJUST.FHEIGHT * 0.45, // 最大高度
                    spaceX: ADJUST.FHEIGHT * 0.1, // X方向留空
                    spaceY: ADJUST.FHEIGHT * 0.1, // Y方向留空
                },
                axisX: { // 纵坐标显示的配置
                    pixel: ADJUST.FHEIGHT * 0.3,
                    height: ADJUST.FHEIGHT * 0.45, // 最大高度
                    spaceX: ADJUST.FHEIGHT * 0.1, // X方向留空
                    spaceY: ADJUST.FHEIGHT * 0.1, // Y方向留空
                },
            },
            config: CLAPI.Utils.mergeObjectOfDeep({
                    title: {
                        label: '当日盈亏',
                    },
                    lines: [{
                        className: CLAPI.ClDrawVBar,
                        extremum: { // 如何取极值
                            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                            maxvalue: ['value0'], // 参与计算最大值的标签
                            minvalue: ['value0'] // 参与计算最小值的标签
                        },
                        info: { // 输出在信息栏目（title）的数据
                            showstyle: 'zero',
                            filled: true,
                            label: '金额:',
                            fieldY: 'value0', // 从key中获取对应的数据标签 用于显示信息用
                            format: 'money',
                        },
                    }],
                },
                ADJUST.CHART_MONEY_FOOT),
            rectMain: curRect
        }
        const curchart = chart.createChart(dreapsName, 'system.fixed', curCfg, function (result) {
            // console.log('KBAR', result)
        })
        chart.bindData(curchart, dreapsName)
    }

}

function drawAdjust(inData, showChart) {

    console.log('Draw ====> Adjust Line')
    // console.log(JSON.stringify(inData));
    console.log(inData);

    const curChart = Init.getSysChart()
    // 得到第一个窗口
    const canvas = Init.canvas
    
    const nameHeight = ADJUST.FHEIGHT * Init.scale
    const infoHeight = ADJUST.FHEIGHT * 0.8 * Init.scale
    const chartWidth = canvas.width

    if (showChart === undefined) 
    {
        showChart = 'showFace'
    }
    curChart.clearChart()
    if (showChart === 'showFace') 
    {
        curChart.initChart(['NameCtrl', 'DateCtrl'])
        setDateCtrl(curChart, 'DateCtrl', inData, {
            style: 'sidebar',
            top: nameHeight,
            left: 0,
            width: chartWidth,
            height: canvas.height - nameHeight,
        })
    }
    if (showChart === 'showInfo') {
        curChart.initChart(['NameCtrl', 'InfoCtrl', 'InfoList'])
        setInfoCtrl(curChart, 'InfoCtrl', inData, {
            style: 'sidebar',
            top: nameHeight,
            left: 0,
            width: chartWidth,
            height: infoHeight,
        })
        setInfoList(curChart, 'InfoList', inData, {
            style: 'average',
            top: nameHeight + infoHeight,
            left: 0,
            width: chartWidth,
            height: canvas.height - nameHeight - infoHeight,
        })
    }
    
    if (showChart === 'showMain') {
        curChart.initChart(['NameCtrl', 'MainBoard', 'MainChart'])
        const boardHeight = canvas.height * 0.3
        setMainBoard(curChart, 'MainBoard', inData, {
            top: nameHeight,
            left: 0,
            width: chartWidth,
            height: boardHeight,
        })
        
        setMainChart(curChart, 'MainChart', inData, {
            style: 'splitly',
            top: nameHeight + boardHeight,
            left: 0,
            width: chartWidth,
            height: canvas.height - nameHeight - boardHeight,
        })
    }

    setNameCtrl(curChart, 'NameCtrl', inData, {
        style: 'sidebar',
        top: 0,
        left: 0,
        width: chartWidth,
        height: nameHeight,
    })
    
    curChart.onPaint()
}


function onLoadData(inData, showChart, newIndex) {
    // 这里新的索引是日期
    function changeAdjustDay(inData) {
        // 判断是否最新的
        let assetsdate = Math.min(inData.showDate, inData.diskDate)
        let adjustdate = inData.showDate
        if (inData.lastDate > inData.diskDate) {
            adjustdate = inData.showDate > inData.diskDate ? 0 : adjustdate
        }
        const adjustName = getAdjustClass(inData)
        const cmds = {
            "assets": {
                "cmd": "get",
                "subject": "assets",
                "service": inData.modulepath + adjustName + "/assets/",
                "info": {
                    "sub-date": assetsdate
                }                
            },
        }
        if (adjustdate > 0) {
            cmds["adjust"] = {
                "cmd": "get",
                "subject": "adjust",
                "service": inData.modulepath + adjustName + "/adjust/",
                "info": {
                    "sub-date": adjustdate
                }
            }
        }
        if (inData.lastDate > 0 && inData.lastDate > inData.diskDate) {
            cmds["nadjust"] = { 
                "cmd" : "redis", 
                "subject" : "signal", 
                "service": '47.242.109.110:17329', 
                "info" : {
                    "command" : "lrange " + "adjust" + ":" + adjustName + ":" + inData.lastDate + " 0 -1"
                }
            }
        }
        Init.sendCommand({ cmds },
            function reply(datas) {
                // console.log(datas);
                if (Init.checkDatas(datas, ['adjust', 'nadjust'])) {
                    if (inData.lastDate > 0 && inData.lastDate > inData.diskDate) {
                        inData['nadjust'] = ADJUST.getRealAdjust(datas['nadjust'])
                    }
                    if (inData.showDate <= inData.diskDate) {
                        inData['adjust'] = datas['adjust']
                        inData['assets'] = ADJUST.getInfoAssets(datas['assets'])
                    }
                    else {
                        inData['adjust'] = inData['nadjust']
                        inData['assets'] = ADJUST.rpsRealAssets(datas['assets'], inData['nadjust'], inData['dates'])
                    }
                    // console.log(inData);
                    drawAdjust(inData, showChart)
                }
            });
    }
    
    const dateindex = Init.getUserInfo(inData.modulename, 'dateindex', 0)
    // console.log(newIndex, dateindex);
    if (newIndex === undefined) {
        newIndex = dateindex
        inData.showDate = CLAPI.getData(inData['dates'], 'date',  newIndex)
        changeAdjustDay(inData)
    }
    else {
        if (newIndex < 0 || newIndex > inData['dates'].datas.length - 1) {
            newIndex = dateindex
        }
        if (newIndex !== dateindex) {
            Init.setUserInfo(inData.modulename, 'dateindex', newIndex)
            inData.showDate = CLAPI.getData(inData['dates'], 'date',  newIndex)
            changeAdjustDay(inData)
        }
    }
}

function onLoadClass(inData, showChart) {

    const adjustName = getAdjustClass(inData)
    Init.sendCommand({
        cmds: {
            "money": {
                "cmd": "get",
                "subject": "money",
                "service": inData.modulepath + adjustName + "/census/",
                "info": {
                    "offset": 0
                },
            },
            "tradedate" : { 
                "cmd" : "redis", 
                "subject" : "tradedate", 
                "service": '47.242.109.110:17329', 
                "info" : {
                    "command" : "get " + "monitor:tradedate"
                }
            },
        }
    },
    function reply(datas) {
        console.log(datas)
        if (Init.checkDatas(datas, ['tradedate'])) {
            inData['money'] = datas['money']
            // 这里设置历史最后一天日期和当日交易日期
            inData.diskDate = CLAPI.getData(inData['money'], 'date',  -1)
            inData['dates'] = ADJUST.moneyToDateinfo(inData['money']);
            // 如果有当日信息 需要在money中增加一条记录
            if (datas['tradedate'].tag === 0) {
                inData.lastDate = datas['tradedate'].infos.currdate
                ADJUST.incrNewDateinfo(inData['dates'], inData.lastDate)
            }  
            onLoadData(inData, showChart)
        }
    });
}

export function onLoad(argvs) {
    let inData = {}
    inData.modulepath = argvs.modulepath ?? 'realtime/'
    inData.modulename = argvs.modulename ?? ['adjustphone']
    inData.moduledata = argvs.moduledata ?? ['admix500L']
    console.log(argvs, inData.modulepath, inData.modulename, inData.moduledata);
    inData.showDate = 0   // 当前显示的日期
    inData.lastDate = 0   // 是否有最新的日期
    inData.diskDate = 0   // 持仓中最新的日期
    onLoadClass(inData)
}
// 参考 spool3 的方法
// 先提取 日期
// 再 

// 注册方法到参数表